export default "__VITE_ASSET__DvCLdy65__"